<p>cult-checkout-defaults works!</p>
